<template>
	<div class="w-100 d-flex align-center justify-start flex-column">
		<div class="flex-center w-100" style="flex-wrap: wrap; max-width: 800px">
			<div
				class="menu-item ma-2 px-4 py-3 small-text pointer"
				:class="{ 'menu-selected': !selectedCategory }"
				@click="selectedCategory = null">
				All
			</div>
			<div
				class="menu-item ma-2 px-4 py-3 small-text pointer"
				v-for="item in partnerCategories"
				:key="item.id"
				:class="{ 'menu-selected': selectedCategory === item.id }"
				@click="selectedCategory = item.id">
				{{ item.name }}
			</div>
		</div>

		<v-row class="w-100 mx-0 mt-3 mb-15" v-if="filteredPartners.length > 0">
			<v-col
				cols="12"
				sm="6"
				md="6"
				v-for="partner in filteredPartners"
				:key="partner.id"
				class="d-flex align-start justify-start">
				<v-card
					theme="dark"
					flat
					color="#fefefe10"
					style="border: 1px solid #fefefe30"
					class="w-100 elevation-1 rounded-1 h-100 d-flex align-space-between flex-column justify-center"
					@click="goToPartner(partner.link)">
					<v-card-title
						class="d-flex align-center justify-space-between w-100 pa-6"
						style="position: relative">
						<img :src="partner.logo" style="height: 50px" />
					</v-card-title>
					<v-divider class="w-100 mb-2"></v-divider>
					<v-card-text class="d-flex align-start justify-start flex-column pb-7 px-6">
						<div class="w-100 text-left d-flex align-center mb-5" style="flex-wrap: wrap">
							<v-chip
								size="small"
								v-for="(cat, c) in partner.categories"
								:key="`${c}-partner-cat`"
								color="#958fc5"
								class="mr-2 text-medium-emphasis purple-color">
								{{ cat.name }}
							</v-chip>
						</div>
						<span class="w-100 text-left text-medium-emphasis">
							{{ partner.description }}
						</span>
					</v-card-text>

					<v-divider class="w-100"></v-divider>

					<v-card-actions class="d-flex align-center justify-end px-6 py-4">
						<v-btn text color="#958fc5" @click="goToPartner(partner.link)" class="normal-spacing">
							Learn More
							<v-icon class="ml-3">mdi-arrow-right</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<p class="text-center white--text white-p mt-10" v-else>No partners found</p>
	</div>
</template>
<script>
	import axios from "axios"
	export default {
		name: "Partners",
		data() {
			return {
				selectedCategory: null,
			}
		},
		props: {
			partners: {
				type: Array,
				required: true,
			},
			partnerCategories: {
				type: Array,
				required: true,
			},
		},
		computed: {
			filteredPartners() {
				let partners = this.partners

				if (this.selectedCategory) {
					return partners.filter((partner) =>
						partner.categories.find((cat) => cat.id == this.selectedCategory),
					)
				} else {
					return partners
				}
			},
		},
		methods: {
			goToPartner(link) {
				window.open(link, "_blank")
			},
		},
	}
</script>
<style scoped lang="scss">
	.menu-item {
		background-color: #4141418e;
		color: #fefefe;
		border-radius: 5px;
		transition: all 0.3s ease;
		font-weight: 500;
	}

	.menu-selected {
		background-color: #958fc5;
		color: #fefefe;
	}

	.category-name {
		font-size: 14px;
		line-height: 14px;
		font-weight: 500;
	}
</style>
